import * as React from "react";
import { Alert, Col, Form, Row, Spinner } from "react-bootstrap";
import { SimpleCheckbox } from "Components/Common/SimpleCheckbox";
import {useUserPreferences, UserPreferences} from "@/hooks/user";
import {ChangeEvent, useState} from "react";
import {EAIClient} from "Services/EAIClient";
import {useAppContext} from "@/contexts/app";


const FREQUENCY_OPTIONS = [
    {value: "immediate", label: "Immediate"},
    {value: "daily", label: "Daily"},
    {value: "weekly", label: "Weekly"},
];

export function NotificationFrequency() {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const {data, error, mutate} = useUserPreferences();
    const {dispatchError} = useAppContext();
    const client = new EAIClient();
    let successTimeout: NodeJS.Timeout;

    const displaySuccessMessage = () => {
        setShowSuccessMessage(true);
        successTimeout = setTimeout(() => {
            setShowSuccessMessage(false);
        }, 3000);
    };

    const handleChangeSave = async (preferences: Partial<UserPreferences>) => {
        if(!!successTimeout){
            clearTimeout(successTimeout);
        }
        try {
            await client.updateCurrentUserPreferences(preferences);
            displaySuccessMessage();
            await mutate();
        } catch (e) {
            dispatchError(e);
        }
    };

    const handleFrequencyChange = (ev: ChangeEvent<HTMLInputElement>) => {
        const newFrequency = ev.target.value as "immediate" | "daily" | "weekly";
        handleChangeSave({notification_frequency: newFrequency});
    };

    const handleAlertClose = () => {
        setShowSuccessMessage(false);
    };
    const handleSummaryToggle = (next: boolean) => {
        handleChangeSave({notification_weekly_summary: next});
    };
    const renderInner = () => {
        if (error) {
            return (
                <Alert variant="danger">{error.message}</Alert>
            );
        }
        if(!data){
            return (<Spinner animation="border"/>);
        }
        return (
            <React.Fragment>
                <Col>{FREQUENCY_OPTIONS.map(obj => (
                    <Form.Check
                        key={ obj.value }
                        type="radio"
                        id={`frequency-radio-${obj.value}`}
                        onChange={ handleFrequencyChange }
                        checked={ obj.value === data.data.preferences.notification_frequency }
                        name="frequencyRadio"
                        value={ obj.value }
                        label={ obj.label }/>
                ))}</Col>
                <Col>
                    <SimpleCheckbox isChecked={data.data.preferences.notification_weekly_summary} id="weekly summary" onChange={handleSummaryToggle} label="Subscribe to Weekly Summary"/>
                </Col>
            </React.Fragment>
        );
    };

    return (
        <Row>
            <Col md={ {span: 6, offset: 3} } className="">
                <div className="success-notification-container">
                    <Alert variant="success" show={showSuccessMessage} dismissible={true} onClose={handleAlertClose}>Changes Saved</Alert>
                </div>
                <fieldset className="fieldset" style={{marginTop: ".25rem"}}>
                    <legend className="fieldset">Email Frequency</legend>
                    <Row className="inner">
                        { renderInner() }
                    </Row>
                </fieldset>
            </Col>
        </Row>
    );
}

